import { Component, OnInit } from "@angular/core";
import { Tab } from "../../models/tabs.model";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../services/auth.service";

@Component({
  selector: "app-hospital-admin",
  templateUrl: "./hospital-admin.component.html",
  styleUrl: "./hospital-admin.component.scss",
})
export class HospitalAdminComponent {

  adminTabs: Tab[] = [
    { text: "User Overview", name: "UserOverview" },
    { text: "Donor Overview", name: "DonorOverview" },
    { text: "Reporting & Analytics", name: "Reporting" },
    { text: "Initial Eligibility Questionnaire", name: "IQuestionnaire" },
    { text: "Comprehensive Questionnaire", name: "CQuestionnaire" },
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  onTabChange(selectedTab: string) {
    this.router.navigate([selectedTab.toLowerCase().replace(/ /g, "-")], {
      relativeTo: this.route,
    });
  }
}
